export const mayAbbreviatedLowercase = "j_hDt";
export default {mayAbbreviatedLowercase};